import { DataDate } from "../model/data_date";
import { Series } from "../model/series";
import { tablemill } from "../tablemill_metal";
import { TrendResearchesForm } from "../view/trend_researches_form";
import { CombinationRankingTableController } from "./combination_ranking_table_controller";
import { RelatedCombinationRecipesController } from "./related_combination_recipes_controller";
import { RelatedCombinationRecipesView } from "../view/related_combination_recipes_view";
import { RecipeData } from "../view/related_recipes_view";
import { TrendRelatedRecipe } from "../model/trend_related_recipe";
import { AgeGroupsController } from "./age_groups_controller";
import { SeasonalPeriodicityController } from "./seasonal_periodicity_controller";
import $ from "jquery";

class TrendResearchesController {
  protected form: TrendResearchesControllerForm;
  protected view: any;
  protected combinationRankingTableController: CombinationRankingTableController;
  protected relatedRecipesController: RelatedCombinationRecipesController;
  private trendRelatedRecipesController: RelatedCombinationRecipesController; // セクション【2】用のレシピコントローラー
  private selection: ItemSelection;
  private currentSelectedItemId: number | null = null; // タグクリックで選択されたitem_idを保持
  private isUpdatingGraph: boolean = false; // グラフ更新中のフラグ（onSeriesRemovalでsubmitしないため）
  private currentDisplayedResearchType: string | null = null; // 現在表示中の追加リサーチタイプ

  constructor() {
    this.form = new TrendResearchesControllerForm();
    this.selection = this.form.selection;
    this.view = new TrendResearchesForm();
    this.combinationRankingTableController =
      new CombinationRankingTableController(
        this.form,
        "ksi",
        this.rankingTableElement(),
      );
    this.relatedRecipesController = new RelatedCombinationRecipesController();
    // セクション【2】用のレシピコントローラーを初期化
    this.trendRelatedRecipesController = new TrendRelatedRecipesController();
  }

  protected formElement(): JQuery<HTMLElement> {
    return $("#matches_form");
  }

  protected typeElement(): JQuery<HTMLElement> {
    return $("#type");
  }

  protected partitionElement(): JQuery<HTMLElement> {
    return $("#partition");
  }

  protected canvasElement(): JQuery<HTMLElement> {
    return $("#ksi_graph");
  }

  protected rankingTableElement(): JQuery<HTMLElement> {
    return $("#ksi_ranking_table");
  }

  onLoad(): void {
    this.initialize();
    if (!this.form.isKeywordFound()) {
      this.view.showKeywordNotFoundError(this.view.keywordValue());
      this.combinationRankingTableController.view.hideIndicator();
      this.relatedRecipesController.view.showNotFoundMessage();
      return;
    }
    this.render();
  }

  private initialize(): void {
    this.selection = this.form.selection;
    const initialItems = this.selection.items();
    // 初期状態の先頭item_idを保持
    if (initialItems.length > 0) {
      this.currentSelectedItemId = initialItems[0];
    }
    this.view.initialize(this.form.invalidParameterCombinations());
    this.combinationRankingTableController.initialize();
    this.relatedRecipesController.initialize();
    // セクション【2】用のレシピコントローラーを初期化
    this.trendRelatedRecipesController.initialize();
    this.registerEventHandlers();

    // 初期状態でレシピ一覧を表示
    if (this.currentSelectedItemId !== null) {
      const initialTagName = $(".combination_keywords .partition_button.selected").data("itemName") as string || "";
      this.updateTrendRelatedRecipes(this.currentSelectedItemId, initialTagName);
    }

    // 初期表示時にtrend_calculation_descriptionをレンダリング
    this.renderInitialTrendCalculation();

    // 初期表示時にtrend_graph_descriptionをレンダリング
    this.renderInitialTrendGraphDescription();
  }

  private renderInitialTrendCalculation(): void {
    const $container = $("#trend_calculation_description");
    if ($container.length === 0) {
      return;
    }

    const keyword = $container.data("keyword") as string;
    const trendCalculationsData = $container.data("trendCalculations");

    if (!keyword || !trendCalculationsData) {
      return;
    }

    // jQueryのdata()メソッドはJSON文字列を自動的にパースする場合があるため、
    // 文字列の場合はパースし、既にオブジェクトの場合はそのまま使用
    let trendCalculations: Array<{ keyword_name: string; increase_rate: number }> = [];
    if (typeof trendCalculationsData === "string") {
      try {
        trendCalculations = JSON.parse(trendCalculationsData);
      } catch (e) {
        console.error("Failed to parse trend_calculations:", e);
        return;
      }
    } else if (Array.isArray(trendCalculationsData)) {
      trendCalculations = trendCalculationsData;
    } else {
      console.error("Invalid trend_calculations data type");
      return;
    }

    const endDate = new Date();
    const currentYear = endDate.getFullYear();
    const lastYear = currentYear - 1;

    this.renderTrendCalculation(keyword, trendCalculations, lastYear, currentYear);
  }

  private renderInitialTrendGraphDescription(): void {
    const $selectedTag = $(".combination_keywords .partition_button.selected");
    if ($selectedTag.length === 0) {
      return;
    }

    const itemName = $selectedTag.data("itemName") as string;
    const increaseRate = parseFloat($selectedTag.data("increaseRate") as string) || 0.0;

    if (itemName) {
      this.updateTrendGraphDescription(itemName, increaseRate);
    }
  }

  private registerEventHandlers(): void {
    this.form.onSubmit((_e: JQuery.SubmitEvent) => {
      if (this.view.keyword.isChanged()) {
        this.selection.clear();
      }
      return true;
    });

    this.view.onAspectChange((aspectElementId: string) => {
      this.view.itemAspect.flipSelectedAspect(aspectElementId);
      this.combinationRankingTableController.updateRankingTable(
        $(`#${aspectElementId}`).data("aspect"),
      );
      return false;
    });

    this.combinationRankingTableController.onItemLinkClick(
      (itemId: number, itemName: string) => {
        this.selectItem(itemId, itemName);
        return false;
      },
    );

    // タグのクリックイベントを登録
    $(document).on("click", ".combination_keywords .partition_button", (e: JQuery.ClickEvent) => {
      const $tag = $(e.currentTarget);
      const itemId = parseInt($tag.data("itemId") as string, 10);
      const itemName = $tag.data("itemName") as string;

      if (itemId && itemName) {
        this.selectKeywordTag(itemId, itemName);
      }
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    // 追加リサーチのボタンクリックイベントを登録
    $(document).on("click", ".research_question_button", (e: JQuery.ClickEvent) => {
      const $button = $(e.currentTarget);
      const questionType = $button.data("type") as string;
      const itemId = $button.data("itemId") as string;
      const keyword = $button.data("keyword") as string;
      const combinationItemId = $button.data("combinationItemId") as string | undefined;
      const combinationItemName = $button.data("combinationItemName") as string | undefined;

      if (questionType && itemId && keyword) {
        this.handleAdditionalResearch(questionType, itemId, keyword, $button, combinationItemId, combinationItemName);
      }
      e.preventDefault();
      return false;
    });
  }

  private selectItem(itemId: number, itemName: string): void {
    if (!this.view.graph.hasSeries(itemName)) {
      this.selection.add(itemId);
      this.form.submit();
    }
  }

  private selectKeywordTag(itemId: number, itemName: string): void {
    // 選択されたitem_idをメモリに保存
    this.currentSelectedItemId = itemId;

    // すべてのタグからselectedクラスを削除
    $(".combination_keywords .partition_button").removeClass("selected");

    // クリックされたタグにselectedクラスを追加
    const $clickedTag = $(`.combination_keywords .partition_button[data-item-id="${itemId}"]`);
    $clickedTag.addClass("selected");

    // selectionをクリアして、選択されたitem_idを1つだけ追加
    this.selection.clear();
    this.selection.add(itemId);

    // タグのdata属性から増加率を取得して表示を更新
    const increaseRate = parseFloat($clickedTag.data("increaseRate") as string) || 0.0;
    const endDate = new Date();
    const currentYear = endDate.getFullYear();
    const lastYear = currentYear - 1;
    const keyword = this.form.keyword();
    const trendCalculations = [{
      keyword_name: itemName,
      increase_rate: increaseRate
    }];
    this.renderTrendCalculation(keyword, trendCalculations, lastYear, currentYear);

    // グラフの説明文も更新
    this.updateTrendGraphDescription(itemName, increaseRate);

    // セクション【2】のレシピ一覧を更新
    this.updateTrendRelatedRecipes(itemId, itemName);

    // セクション【3】の追加リサーチパネルが開いている場合は閉じる
    this.closeAdditionalResearchPanels();

    // セクション【3】の追加リサーチボタンのdata属性を更新
    this.updateAdditionalResearchButtons(itemId, itemName);

    // グラフを再描画
    this.updateGraphForSelection();
  }

  private updateTrendRelatedRecipes(itemId: number, itemName: string): void {
    // レシピコントローラーにpairing_item_idsを設定
    this.trendRelatedRecipesController.setPairingItemIds([itemId]);

    // レシピを取得して表示（件数制限はコントローラー側で実施）
    this.trendRelatedRecipesController.render().then((recipes: any) => {
      // レシピが存在するか確認
      const hasRecipes = Object.values(recipes).some((recipeList: any) => recipeList.length > 0);

      // レシピを再描画
      this.trendRelatedRecipesController.view.renderRelatedRecipes(recipes);

      // レシピが存在する場合のみ説明文を更新
      if (hasRecipes) {
        // 説明文を更新（キーワードとタグ名を反映）
        this.updateTrendRelatedRecipesDescription(itemName);
        // 説明文とアノテーションを表示
        $(".section_title").filter((_, el) => {
          return $(el).text().includes("ユーザーが関心を持っているレシピ");
        }).nextAll("p.description, p.annotation").show();
      } else {
        // レシピが0件の場合は説明文とアノテーションを非表示
        $(".section_title").filter((_, el) => {
          return $(el).text().includes("ユーザーが関心を持っているレシピ");
        }).nextAll("p.description, p.annotation").hide();
      }
    });
  }

  private updateTrendRelatedRecipesDescription(tagName: string): void {
    const keyword = this.form.keyword();
    // 説明文のタグ名部分を更新
    $(".section_title").filter((_, el) => {
      return $(el).text().includes("ユーザーが関心を持っているレシピ");
    }).nextAll("p.description").first().html(`
      「${$("<div>").text(keyword).html()}」と「${$("<div>").text(tagName).html()}」の要素をもつレシピのうち、近年のユーザーに人気のものは以下の通りです。
    `);

    // サブタイトルのタグ名部分を更新
    $(".section_title").filter((_, el) => {
      return $(el).text().includes("ユーザーが関心を持っているレシピ");
    }).nextAll("p.description").eq(1).html(`
      <b>「${$("<div>").text(keyword).html()}」</b>
      ×
      <b>「${$("<div>").text(tagName).html()}」</b>
      の人気レシピ
    `);
  }

  private renderTrendCalculation(
    keyword: string,
    trendCalculations: Array<{ keyword_name: string; increase_rate: number }>,
    lastYear: number,
    currentYear: number
  ): void {
    const $container = $("#trend_calculation_description");
    let html = "";

    if (trendCalculations && trendCalculations.length > 0) {
      const escapedKeyword = this.escapeHtml(keyword);

      trendCalculations.forEach((calc, index) => {
        const escapedKeywordName = this.escapeHtml(calc.keyword_name);
        const formattedIncreaseRate = calc.increase_rate >= 0
          ? `+${calc.increase_rate.toFixed(1)}%`
          : `${calc.increase_rate.toFixed(1)}%`;

        if (calc.increase_rate > 0) {
          html += `<p class="description">
            <b>「${escapedKeyword}」</b>
            ×
            <b>「${escapedKeywordName}」</b>
            の組み合わせは、前年比で
            <b>${formattedIncreaseRate}</b>
            の上昇を示しています(赤丸箇所)。
          </p>`;
        } else {
          html += `<p class="description">
            <b>「${escapedKeyword}」</b>
            ×
            <b>「${escapedKeywordName}」</b>
            の組み合わせは、前年比で
            <b>${formattedIncreaseRate}</b>
            の減少を示しています(赤丸箇所)。
          </p>`;
        }

        if (index < trendCalculations.length - 1) {
          html += "<br>";
        }
      });
    } else {
      html = `<p class="trend_description">
        データが不足しているため、増加率の計算ができませんでした。
      </p>`;
    }

    $container.html(html);
  }

  private updateTrendGraphDescription(itemName: string, increaseRate: number): void {
    const $container = $("#trend_graph_description");
    if ($container.length === 0) {
      return;
    }

    $container.html(`
      <p class="annotation">
        SI値とはSearch Indexの略で、1000回あたりの検索頻度です。「SI値＝分析ワードの検索回数÷全体の検索回数×1000」で算出されます。破線部分は今月のSI値の着地見通しを示しており、昨年同月のSI値に、直近24ヶ月間のSI値の変化傾向を反映した係数を乗じています。
      </p>
    `);
  }

  private updateGraphForSelection(): void {
    // グラフ更新中のフラグを設定（onSeriesRemovalでsubmitしないため）
    this.isUpdatingGraph = true;

    // 既存のシリーズをすべて削除
    const seriesCount = this.view.graph.seriesCount();
    for (let i = seriesCount - 1; i >= 0; i--) {
      const series = this.view.graph.getSeries(i);
      this.view.graph.removeSeries(series);
    }

    // グラフをクリア
    this.view.graph.clear();

    // 新しいグラフを描画
    this.renderGraphs()
      .then((_res: any) => {
        const currentSelectionItems = this.currentSelectedItemId !== null
          ? [this.currentSelectedItemId]
          : this.selection.items();
        this.relatedRecipesController.setPairingItemIds(currentSelectionItems);
        return this.relatedRecipesController.render();
      })
      .then(
        (_res: any) => {
          if (this.view.graph.hasNoData()) {
            this.view.showNoDataMessage();
          } else {
            this.view.render();
          }
        },
        (res: any) => {
          this.view.showHttpErrorMessage(res);
        },
      )
      .then((_res: any) => {
        const currentSelectionItems = this.currentSelectedItemId !== null
          ? [this.currentSelectedItemId]
          : this.selection.items();
        this.view.updateCsvUrl(
          this.form
            .newCombinationDataSeriesQuery(null, currentSelectionItems)
            .csvUrl(),
        );
        // グラフ更新完了後、フラグをリセット
        this.isUpdatingGraph = false;
      });
  }

  private highlightSelection(): void {
    this.selection.items().forEach(() => {
      this.combinationRankingTableController.highlightSelection();
    });
  }

  protected render(): void {
    // タグクリックで選択されたitem_idを優先する
    const selectionItems = this.currentSelectedItemId !== null
      ? [this.currentSelectedItemId]
      : this.selection.items();

    // ランキングテーブルをスキップして、直接グラフを描画
    this.renderGraphs()
      .then((_res: any) => {
        this.relatedRecipesController.setPairingItemIds(selectionItems);
        return this.relatedRecipesController.render();
      })
      .then(
        (_res: any) => {
          if (this.view.graph.hasNoData()) {
            this.view.showNoDataMessage();
          } else {
            this.view.render();
          }
        },
        (res: any) => {
          this.view.showHttpErrorMessage(res);
        },
      )
      .then((_res: any) => {
        this.view.updateCsvUrl(
          this.form
            .newCombinationDataSeriesQuery(null, selectionItems)
            .csvUrl(),
        );
        this.view.enablePngDownload();
      });

    this.view.onSeriesRemoval((_index: number, series: any) => {
      // グラフ更新中（タグクリックによる自動削除）の場合はsubmitしない
      if (this.isUpdatingGraph) {
        return;
      }
      this.selection.remove(series.itemId);
      $("#kumiawase_keyword").val("");
      this.form.submit();
    });
  }

  private renderGraphs(): JQuery.Promise<any> {
    // タグクリックで選択されたitem_idを優先する
    const selectionItems = this.currentSelectedItemId !== null
      ? [this.currentSelectedItemId]
      : this.selection.items();
    const graphPromises = selectionItems.map((pairingItemId: number) => this.renderEachGraph(pairingItemId));

    if (graphPromises.length === 0) {
      return $.Deferred().resolve().promise();
    }

    return $.when(...graphPromises).done((...results: any[]) => {
      results.forEach((series: any) => {
        this.view.graph.addSeries(series);
      });
    }).fail((_error: any) => {
      // エラーは無視（既存のエラーハンドリングで処理される）
    });
  }

  private renderEachGraph(pairingItemId: number): JQuery.Promise<any> {
    const dfd = $.Deferred<any>();
    const query = this.form.newCombinationDataSeriesQuery(pairingItemId);

    query.execute().then(
      (series: any) => {
        series.itemId = pairingItemId;
        dfd.resolve(series);
      },
      (error: any) => {
        dfd.reject(error);
      },
    );
    return dfd.promise();
  }

  private handleAdditionalResearch(
    questionType: string,
    itemId: string,
    keyword: string,
    $button: JQuery<HTMLElement>,
    combinationItemId?: string,
    combinationItemName?: string,
  ): void {
    // 同じボタンを再度クリックした場合は何もしない
    if (this.currentDisplayedResearchType === questionType) {
      return;
    }

    // すべてのボタンからactiveクラスを削除
    $(".research_question_button").removeClass("active");

    // クリックされたボタンにactiveクラスを追加
    $button.addClass("active");

    // 現在表示中のコンテンツとタイトルを非表示にする
    if (this.currentDisplayedResearchType) {
      const $currentContainer = $(`#research_result_${this.currentDisplayedResearchType}`);
      const $currentTitle = $(`#research_result_title_${this.currentDisplayedResearchType}`);
      if ($currentContainer.length > 0) {
        $currentContainer.hide();
      }
      if ($currentTitle.length > 0) {
        $currentTitle.hide();
      }
    }

    // additional_research_results内のコンテナを取得または作成
    const $resultsArea = $(".additional_research_results");
    if ($resultsArea.length === 0) {
      console.error(".additional_research_results element not found");
      return;
    }

    const containerId = `research_result_${questionType}`;
    const titleId = `research_result_title_${questionType}`;
    let $resultContainer = $(`#${containerId}`);
    let $titleElement = $(`#${titleId}`);

    // タイトル要素を作成または取得
    const titleText = this.getResearchTitle(questionType, keyword, combinationItemName);
    if ($titleElement.length === 0) {
      $titleElement = $(`<p class="description" id="${titleId}">${titleText}</p>`);
      $resultsArea.append($titleElement);
    } else {
      // 既に存在する場合はテキストを更新（タグ切り替えなどでキーワードが変わった場合に対応）
      $titleElement.text(titleText);
    }

    if ($resultContainer.length === 0) {
      $resultContainer = $(`<div id="${containerId}" class="research_result"></div>`);
      $resultsArea.append($resultContainer);
    }

    // タイトルとコンテナを表示
    $titleElement.show();
    $resultContainer.show();
    this.currentDisplayedResearchType = questionType;

    // 既にコンテンツが描画されているかチェック（data属性で管理）
    const isRendered = $resultContainer.data("rendered") === true;

    // 既に描画済みの場合は何もしない（表示のみ）
    if (isRendered) {
      return;
    }

    // ボタンを無効化（重複クリック防止）
    $button.prop("disabled", true);

    // generation_interestタイプの場合は世代別グラフを表示
    if (questionType === "generation_interest") {
      const controller = new AgeGroupsController($resultContainer);
      controller
        .render(keyword, combinationItemName)
        .always(() => {
          // 描画済みフラグを設定
          $resultContainer.data("rendered", true);
          // ボタンを再度有効化
          $button.prop("disabled", false);
        });
      return;
    }

    // seasonal_periodicityタイプの場合は季節的周期性グラフを表示
    if (questionType === "seasonal_periodicity") {
      if (!combinationItemName) {
        $resultContainer.html(
          `<div class="research_error"><p>${this.escapeHtml("組み合わせキーワードが必要です。")}</p></div>`,
        );
        $resultContainer.data("rendered", true);
        $button.prop("disabled", false);
        return;
      }
      const controller = new SeasonalPeriodicityController($resultContainer);
      controller
        .render(keyword, combinationItemName)
        .always(() => {
          // 描画済みフラグを設定
          $resultContainer.data("rendered", true);
          // ボタンを再度有効化
          $button.prop("disabled", false);
        });
      return;
    }

    // その他のタイプはサポートされていません
    $resultContainer.html(
      `<div class="research_error"><p>${this.escapeHtml("このタイプのリサーチは現在サポートされていません。")}</p></div>`,
    );
    $resultContainer.data("rendered", true);
    $button.prop("disabled", false);
  }

  private escapeHtml(text: string): string {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }

  private closeAdditionalResearchPanels(): void {
    // 開いているすべての追加リサーチ結果パネルとタイトルを閉じる
    $(".additional_research_results .research_result").hide();
    $(".additional_research_results .research_result_title").hide();
    // タイトル要素は削除せずに非表示にする（次回表示時にテキストを更新するため）
    this.currentDisplayedResearchType = null;
    // すべてのボタンからactiveクラスを削除
    $(".research_question_button").removeClass("active");
    // タグが変わった場合は描画済みフラグをリセット（キーワードが変わる可能性があるため）
    $(".additional_research_results .research_result").removeData("rendered");
    $(".additional_research_results .research_result").empty();
  }

  /**
   * 質問タイプに応じた調査タイトルを取得
   */
  private getResearchTitle(questionType: string, keyword: string, combinationItemName?: string): string {
    const escapedKeyword = this.escapeHtml(keyword);
    const escapedCombinationItemName = combinationItemName ? this.escapeHtml(combinationItemName) : "";

    switch (questionType) {
      case "generation_interest":
        if (escapedCombinationItemName) {
          return `世代別に「${escapedKeyword}」×「${escapedCombinationItemName}」の関心について調査しました。`;
        } else {
          return `世代別に「${escapedKeyword}」の関心について調査しました。`;
        }
      case "seasonal_periodicity":
        if (escapedCombinationItemName) {
          return `「${escapedKeyword}」×「${escapedCombinationItemName}」の季節的な周期性について調査しました。`;
        } else {
          return `「${escapedKeyword}」の季節的な周期性について調査しました。`;
        }
      default:
        return `「${escapedKeyword}」について調査しました。`;
    }
  }

  private updateAdditionalResearchButtons(combinationItemId: number, combinationItemName: string): void {
    const escapedCombinationItemName = this.escapeHtml(combinationItemName);

    // すべての追加リサーチボタンのdata属性とテキストを更新
    $(".research_question_button").each((_, button) => {
      const $button = $(button);
      const questionType = $button.data("type") as string;

      // 検索ボックスの値ではなく、ボタンのdata-keyword属性から値を取得（サーバーから返された正しい値）
      const keyword = $button.data("keyword") as string || this.form.keyword();
      const escapedKeyword = this.escapeHtml(keyword);

      // data属性を更新
      $button.data("combinationItemId", combinationItemId);
      $button.data("combinationItemName", combinationItemName);

      // ボタンのテキストを更新（タイプに応じて）
      let newText = "";
      switch (questionType) {
        case "generation_interest":
          newText = `世代別に「${escapedKeyword}」×「${escapedCombinationItemName}」の関心が知りたい`;
          break;
        case "seasonal_periodicity":
          newText = `「${escapedKeyword}」×「${escapedCombinationItemName}」の季節的な周期性を知りたい`;
          break;
        default:
          // その他のタイプは既存のテキストを保持
          return;
      }
      $button.text(newText);
    });
  }
}

class TrendResearchesControllerForm {
  selection: ItemSelection;

  constructor() {
    this.selection = new ItemSelection();
  }

  formElement(): JQuery<HTMLElement> {
    return $("#matches_form");
  }

  submit(): void {
    this.formElement().trigger("submit");
  }

  onSubmit(f: (e: JQuery.SubmitEvent) => boolean): void {
    this.formElement().on("submit", f);
  }

  combinationDataSeriesUrl(): string {
    return $("#ksi_graph").data("ajaxUrl");
  }

  combinationRankingTableUrl(): string {
    return $("#ksi_ranking_table").data("ajaxUrl");
  }

  type(): string {
    return $("#type").val() as string;
  }

  partition(): string {
    return $("#partition").val() as string;
  }

  isKeywordFound(): boolean {
    return !$("#keyword").data("notFound");
  }

  targetDataDate(): any {
    return DataDate.parseYMD($("#target").val() as string, this.partition());
  }

  dimension(): string {
    return $("#dimension").val() as string;
  }

  area(): string {
    return $("#area").val() as string;
  }

  category(): string {
    return $("#category").val() as string;
  }

  keyword(): string {
    return $("#keyword").val() as string;
  }

  itemId(): string {
    return $("#item_id").val() as string;
  }

  maxRank(): string {
    return $("#max_rank").val() as string;
  }

  startDate(): string {
    return $("#ranking_start").val() as string;
  }

  endDate(): string {
    return $("#ranking_end").val() as string;
  }

  newCombinationDataSeriesQuery(
    pairingItemId?: number | null,
    selection?: number[],
  ): CombinationDataSeriesQuery {
    return new CombinationDataSeriesQuery(this, pairingItemId, selection);
  }

  newCombinationRankingTableQuery(aspectId: number): any {
    return new CombinationRankingTableQuery(this, aspectId);
  }

  invalidParameterCombinations(): any {
    return this.formElement().data("invalidParameterCombinations");
  }
}

class ItemSelection {
  private static readonly ITEM_CLASS = "selectingItemId";

  private containerElement(): JQuery<HTMLElement> {
    return $("#itemSelection");
  }

  items(): number[] {
    return $(`.${ItemSelection.ITEM_CLASS}`)
      .map((i, elem) => parseInt($(elem).val() as string, 10))
      .get();
  }

  add(itemId: number): void {
    const strItemId = itemId.toString();
    if (this.items().indexOf(parseInt(strItemId, 10)) === -1) {
      const id = parseInt(strItemId, 10);
      const input = `<input class='${ItemSelection.ITEM_CLASS}' name='selection[]' type='hidden' value='${id}'>`;
      this.containerElement().append(input);
    }
  }

  remove(itemId: number): void {
    $(`.${ItemSelection.ITEM_CLASS}[value*='${itemId}']`).remove();
  }

  clear(): void {
    this.containerElement().empty();
  }
}

class CombinationDataSeriesQuery {
  private form: TrendResearchesControllerForm;
  private pairingItemId?: number | null;
  private selection?: number[];

  constructor(
    form: TrendResearchesControllerForm,
    pairingItemId?: number | null,
    selection?: number[],
  ) {
    this.form = form;
    this.pairingItemId = pairingItemId;
    this.selection = selection;
  }

  execute(): JQuery.Promise<any> {
    return $.ajax({
      url: this.form.combinationDataSeriesUrl(),
      dataType: "json",
      data: this.makeParams(),
    }).then((res: any) => {
      // series_set配列が返される場合と、直接name/valuesが返される場合の両方に対応
      let seriesData: any;
      if (res.series_set && res.series_set.length > 0) {
        seriesData = res.series_set[0];
      } else {
        seriesData = res;
      }

      // データの最初の日付をoriginとして使用（月次データの場合）
      // projected_statsエンドポイントから取得したデータは月次データなので、最初の日付をoriginとして設定
      let origin: DataDate | undefined;
      if (seriesData.values && seriesData.values.length > 0) {
        const firstValue = seriesData.values[0];
        if (Array.isArray(firstValue) && firstValue.length > 0) {
          const firstDateStr = firstValue[0]; // [date, value, is_projected]の形式
          origin = DataDate.parseYMD(firstDateStr, "monthly") || undefined;
        }
      }

      // originが設定されていない場合は、startDate()を使用（後方互換性のため）
      if (!origin) {
        origin = this.startDate();
      }

      return new Series(seriesData.values, seriesData.name, origin);
    });
  }

  private makeParams(): any {
    const params: any = {
      type: this.form.type(),
      partition: this.form.partition(),
      start: this.startDate().ymd(),
      end: this.form.targetDataDate().ymd(),
      dimension: this.form.dimension(),
      area: this.form.area(),
      category: this.form.category(),
    };

    if (this.pairingItemId != null) {
      params.pairing_item_id = this.pairingItemId;
    } else {
      params.pairing_item_ids = this.selection;
    }

    return params;
  }

  private startDate(): any {
    const end = this.form.targetDataDate();
    switch (end.partition) {
      case "weekly":
        return end.partitionStartDate().weeksAgo(11);
      case "monthly":
        return end.partitionStartDate().yearsAgoByDays(0.97);
      case "yearly":
        return new DataDate(tablemill.FIRST_DATA_DATE, "yearly");
      default:
        return end.partitionStartDate();
    }
  }

  csvUrl(): string {
    return `/combinations/${this.form.itemId()}/stats.csv?${$.param(this.makeParams())}`;
  }
}

class CombinationRankingTableQuery {
  private form: TrendResearchesControllerForm;
  private aspectId: number;

  constructor(form: TrendResearchesControllerForm, aspectId: number) {
    this.form = form;
    this.aspectId = aspectId;
  }
}

// セクション【2】用のViewクラス
// #trend_related_recipes_box 内に直接レシピを表示する（既存のHTML構造を利用）
class TrendRelatedRecipesView extends RelatedCombinationRecipesView {
  constructor(rootElement: JQuery, keyword: string) {
    super(rootElement, keyword);
  }

  initialize(): void {
    // パーシャルで既にHTMLがレンダリングされているので、
    // .recipes_boxを作成する代わりに、rootElementを直接使用
    this.recipesBoxElement = this.rootElement;
  }

  renderRelatedRecipes(groupedRecipes: RecipeData[]): void {
    this.removeIndicator();

    // レシピが存在するか確認
    const hasRecipes = Object.values(groupedRecipes).some((recipes) => recipes.length > 0);

    if (hasRecipes) {
      // ヘッダーを表示しない（パーシャルで既にタイトルがあるため）
      Object.entries(groupedRecipes).forEach(([_pairingItem, recipes]) => {
        if (recipes.length > 0) {
          // コントローラー側で件数制限されているため、そのまま表示
          recipes.forEach((recipeData) => {
            const recipe = new TrendRelatedRecipe(recipeData, this.blankLogoSrc());
            this.recipesBoxElement!.append(recipe.toHtml());
          });
        }
      });
    } else {
      this.showNotFoundMessage();
    }
  }

  protected showNotFoundMessage(): void {
    this.removeIndicator();
    this.renderMessage("関連レシピの検索結果は0件でした。");
  }
}

// セクション【2】用のレシピコントローラー
// #trend_related_recipes_box を使用する
class TrendRelatedRecipesController extends RelatedCombinationRecipesController {
  constructor() {
    super();
    // #trend_related_recipes_box用のViewに置き換え
    this.view = new TrendRelatedRecipesView(
      this.trendRelatedRecipesBoxElement(),
      this.getKeywordFromElement(),
    );
  }

  protected trendRelatedRecipesBoxElement(): JQuery<HTMLElement> {
    return $("#trend_related_recipes_box");
  }

  protected relatedRecipesBoxElement(): JQuery<HTMLElement> {
    return this.trendRelatedRecipesBoxElement();
  }

  private getKeywordFromElement(): string {
    return this.trendRelatedRecipesBoxElement().data("keyword");
  }
}

export { TrendResearchesController, TrendResearchesControllerForm };
